// extracted by mini-css-extract-plugin
module.exports = {"viewer":"Viewer_viewer__3UXgR","checkBg":"Viewer_checkBg__OR67Q"};